import axios from 'axios';

export const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("auth_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const propertyAPI = {
  getAllProperties: (params) => API.get('/properties', { params }),
  getPropertyById: (id) => API.get(`/properties/${id}`),
  getPropertiesInBounds: (bounds) => API.get('/properties/bounds', { params: bounds }),
  getGridClusters: (bounds) => API.get('/properties/grid', { params: bounds }),
  getPropertiesInRadius: (params) => API.get('/properties/radius', { params }),
  getPropertyTypes: () => API.get('/properties/types'),
  filterProperties: (filters) => API.post('/properties/filter', filters),
  getStats: () => API.get('/properties/stats'),
  getOpportunityScores: () => API.get('/properties/opportunity-scores'),
  getRentGap: (propertyId) => API.get(`/properties/${propertyId}/rent-gap`),
  getMarketAnalysis: (submarket) => API.get('/properties/market-analysis', { params: { submarket } }),
  uploadExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return API.post('/properties/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

// Export functionality
export const exportAPI = {
  exportCSV: (properties) => API.post('/export/csv', { properties }),
  exportPDF: (properties) => API.post('/export/pdf', { properties }),
  exportExcel: (properties) => API.post('/export/excel', { properties })
};

// Mock CRM API (for future integration)
export const crmAPI = {
  getNotes: (propertyId) => API.get(`/crm/properties/${propertyId}/notes`),
  getTasks: (propertyId) => API.get(`/crm/properties/${propertyId}/tasks`),
  getLeads: (propertyId) => API.get(`/crm/properties/${propertyId}/leads`),
  createNote: (propertyId, note) => API.post(`/crm/properties/${propertyId}/notes`, note),
  createTask: (propertyId, task) => API.post(`/crm/properties/${propertyId}/tasks`, task),
  createLead: (propertyId, lead) => API.post(`/crm/properties/${propertyId}/leads`, lead)
};